import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';
import { SubscricaoModel } from '../models';

@Injectable({
  providedIn: 'root',
})
export class SubscricaoService {
  context = '/subscricao';
  constructor(private apiService: ApiService) {}

  add(subscricao: any): Observable<any> {
    return this.apiService.post(`${this.context}`, subscricao);
  }

  carregarComprovativo(data: any, anexo: File): Observable<any> {
    var body = new FormData();
    body.append('comprovativo', anexo);
    body.append('pagamentoInput', JSON.stringify(data));

    return this.apiService.put(
      `${this.context}/${data.id}/subscricao-comprovativo`,
      body
    );
  }

  getAll(params): Observable<any> {
    return this.apiService.get(`${this.context}`, params);
  }

  getById(id: string): Observable<any> {
    return this.apiService.get(`${this.context}/${id}`);
  }

  // getByUtilizador(id: number): Observable<any> {
  //   return this.apiService.get(`${this.context}?utilizador=${id}`);
  // }

  update(area: any): Observable<any> {
    const { id } = area;
    return this.apiService.put(`${this.context}/${id}`, area);
  }

  delete(id: string) {
    return this.apiService.delete(`${this.context}/${id}`);
  }
}
